import React, { Component } from 'react';
import './About.css';

const BOARD_MEMBERS = [
  {
    name: 'Adarsh Mavathaveedu',
    image: '/images/profileimg/national/adarshmava.webp',
    positions: [
      'Co-Founder',
      'Chairman and CEO (2024 - 2026)',
      // 'Rochester: President (2022 - 2023)',
      // 'Rochester: Director of Outreach (2023 - 2024)',
    ],
    text: "I'm Adarsh Mavathaveedu, a recent graduate of the University of Rochester. As the eldest child in an immigrant family, I navigated the complex college application process with little to no guidance. The high cost of academic counseling services further discouraged me from seeking external support. It wasn't until after my own application cycle that I realized the immense importance of not only an applicant's profile but also how an application is constructed and presented. This insight motivated me to assemble a team of accomplished students from my university, leading to the creation of Project LTF—a free, student-led initiative dedicated to helping others craft outstanding applications.",
  },
  {
    name: 'Hana Zhang',
    image: '/images/profileimg/national/hanazhang.webp',
    positions: [
      'Co-Founder, CEO',
      'Chief Operating Officer (2022-2026)',
      // 'Rochester: Executive Advisor (2024 - 2026)',
      // 'Rochester: President (2023 - 2024)',
      // 'Rochester: Vice President (2022 - 2023)',
    ],
    text: "Hi, I'm Hana, a Public Health major on the pre-med track at the University of Rochester in the Class of 2026. As the oldest daughter in an immigrant family, I navigated the college application process largely on my own, balancing affordability and ambition. Without access to costly services, I spent countless hours researching schools, scholarships, and essays. This inspired me to co-found Project Level the Field, providing free college mentorship to students who need it most. In my free time, I volunteer as an EMT, enjoy watching movies, and love spending time with my Yorkie, Vienna.",
  },
  {
    name: 'Krish Patel',
    image: '/images/profileimg/national/krishpatel.webp',
    positions: [
      'COO',
      'National Board of Directors (2024-2026)',
    ],
    text: '',
  },
  {
    name: 'Brandon Sookoo',
    image: '/images/profileimg/national/brandonsookoo.webp',
    positions: [
      'CFO',
    ],
    text: "I'm Brandon Sookoo, an undergraduate at the University of Rochester studying Financial Economics. As a first-generation American and college student, I've experienced firsthand the challenges of navigating higher education, financial aid, and career development. Thanks to the hard work and sacrifice of my parents, I had the opportunity to pursue college and deepen my understanding of these systems. As CFO, I aim to combine my finance background with my commitment to supporting underrepresented students—and help Level the Field for those following a similar path.",
  },
  {
    name: 'Keira Donnelly',
    image: '/images/profileimg/national/keiradonnel.webp',
    positions: [
      'Co-Founder',
      'National Board of Directors (2022 - 2026)',
      // 'Rochester: Director of Mentorship (2022 - )',
    ],
    text: "I'm Keira Donnelly, a junior at the University of Rochester studying neuroscience and psychology on the pre-med track. Growing up, my mom, who worked in the Rochester City School District, instilled in me the importance of accessible, quality education for all students. This passion led me to co-found Project Level the Field, an organization that helps low-income students navigate the college application process. As a high school student, I struggled with the application process and lacked guidance. Now, I'm excited to use my experience to support others in the same way I once needed.",
  },
  {
    name: 'Michael Christof',
    image: '/images/profileimg/national/michaelchristof.webp',
    positions: [
      'National Board of Directors (2022 - 2026)',
      // 'Rochester: Director of Operations (2022 - 2023)',
    ],
    text: "I'm Michael Christof, a recent graduate of the University of Rochester. Having been on both ends of the admissions prep companies and professional college tutoring services, I know what to look for in successful applicants. Project LTF bridges the gap by providing students looking for help with free mentorship. We give insight from college students who have already gone through the process. With any higher-education process, crafting your story is key and I hope to share how to do so with our mentees.",
  },
  {
    name: 'Milan Patel',
    image: '/images/profileimg/national/milanpatel.webp',
    positions: [
      'National Board of Directors (2022 - 2026)',
    ],
    text: "Milan Patel is an undergraduate student studying Biomedical Engineering with a concentration in biosignals and a Computational Biology minor at the University of Rochester. Milan is a research assistant at the Asaro Big Data Lab, investigating the effects of dopamine on creative cognition in mice. As curriculum director, he is working with chapter leadership to revamp our mentee curriculum and track mentee progress.",
  },
  // {
  //   name: 'Ava Brophy',
  //   image: '/images/profileimg/national/avabrophy.webp',
  //   positions: [
  //     'National Marketing Committee Director (2024 - )',
  //     // 'Rochester: Director of Marketing (2024 - )',
  //   ],
  //   text: "Hi my name is Ava and I'm a junior at the University of Rochester! In high school, the idea of college was very intimidating to me. I avoided considering universities and the overall unknowns of life beyond my small town. However, looking back on my experience I recognize how valuable, rewarding, and exciting the application process is. I look forward to being a source of advice and encouragement for students. I am thankful for all I have learned throughout my own experiences, and am eager to share my guidance with others!",
  // },
  {
    name: 'Valerie Voytsekhovskaya',
    image: '/images/profileimg/national/ValerieVoytsekhovskaya.webp',
    positions: [
      'National Board of Directors (2022 - 2026)',
      // 'Rochester: Vice President (2024 - )',
      // 'Rochester: Director of Mentorship (2023 - 2024)',
    ],
    text: "As a student who had minimal resources, I'm forever grateful to the people who volunteered their time and knowledge to mentor me in my application cycle. I firsthand know how life-changing good mentorship can be—from offering the right advice to just alleviating the emotional burden of a process that can feel very daunting. At Project LTF, it's a great joy to partake in helping students take their next steps towards their future. Beyond LTF, I'm a current Junior in the BS/MD program doing stem cell research. I also love the great outdoors, making puzzles with friends, and baking cookies!",
  },
];

/** Returns the member's primary national title (a position without a chapter prefix). */
const getPrimaryTitle = (member) => {
  if (!member?.positions?.length) return 'National Leadership';
  const national = member.positions.find((role) => !role.includes(':'));
  return national || member.positions[0];
};

class About extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMember: null,
    };
  }

  componentWillUnmount() {
    document.body.style.overflow = '';
  }

  openBio = (member) => {
    this.setState({ selectedMember: member });
    document.body.style.overflow = 'hidden';
  };

  closeBio = () => {
    this.setState({ selectedMember: null });
    document.body.style.overflow = '';
  };

  render() {
    const { selectedMember } = this.state;

    return (
      <div className="about-page">

        {/* Page header */}
        <section className="about-hero">
          <p className="about-hero__eyebrow">National Leadership</p>
          <h1>The people behind the mission.</h1>
          <p className="about-hero__body">
            A volunteer board of founders, strategists, and operators guiding every
            program and chapter across the country.
          </p>
        </section>

        {/* Team grid */}
        <section className="team-grid">
          {BOARD_MEMBERS.map((member) => (
            <button
              key={member.name}
              type="button"
              className="team-card"
              onClick={() => this.openBio(member)}
            >
              <div className="team-card__photo">
                <img src={member.image} alt={member.name} loading="lazy" />
              </div>
              <div className="team-card__info">
                <p className="team-card__name">{member.name}</p>
                <p className="team-card__title">{getPrimaryTitle(member)}</p>
              </div>
            </button>
          ))}
        </section>

        {/* Bio modal */}
        <div
          className={`bio-modal ${selectedMember ? 'is-open' : ''}`}
          aria-hidden={!selectedMember}
          aria-modal={!!selectedMember}
          role="dialog"
        >
          <div className="bio-modal__backdrop" onClick={this.closeBio} />
          {selectedMember && (
            <div className="bio-modal__panel">
              <button
                className="bio-modal__close"
                onClick={this.closeBio}
                aria-label="Close"
              >
                ✕
              </button>

              <div className="bio-modal__photo">
                <img src={selectedMember.image} alt={selectedMember.name} loading="lazy" />
              </div>

              <div className="bio-modal__body">
                <p className="bio-modal__eyebrow">{getPrimaryTitle(selectedMember)}</p>
                <h2 className="bio-modal__name">{selectedMember.name}</h2>

                <ul className="bio-modal__roles">
                  {selectedMember.positions.map((pos, i) => (
                    <li key={i}>{pos}</li>
                  ))}
                </ul>

                <p className="bio-modal__text">{selectedMember.text}</p>
              </div>
            </div>
          )}
        </div>

      </div>
    );
  }
}

export default About;
